export const environment = {
  production: false,
  baseUrl: 'https://api-simulation.bricksandagent.com',
  baseUrlVersion: '1.0',
  idp: {
    authority: 'https://identitysimulation.bricksandagent.com',
    clientId: '144e251b-30ff-4027-be96-0623e40cbc19',
    scope:
      'openid offline_access custom.profile https://bricksandagent.com/maintenance.api https://bricksandagent.com/agencymgmt.api https://bricksandagent.com/tradeemgmt.api',
  },
  iframe_integration: {
    origins: [
      'https://ptsimulation.bricksandagent.com',
      'https://demo.propertytree.com/',
    ],
    destinations: ['https://localhost:5200'],
  },
  agencyMgmt: {
    urlPrefix: '/agencymgmt/api',
    agencyDefaultLocation: 'Australia',
  },
  maintenance: {
    urlPrefix: '/maintenance/api',
  },
  tradeMgmt: {
    urlPrefix: '/trademgmt/api',
  },
  ruleEngine: {
    urlPrefix: '/rule-engine/api',
  },
  pam: {
    urlPrefix: '/pam/api',
  },
  firebase: {
    apiKey: 'AIzaSyAVQ8HsfWe6nY_IMFtlZu3QSZ4yZqd-icY',
    authDomain: 'bricksandagentservices.firebaseapp.com',
    databaseURL: 'https://bricksandagentservices-maintenance.firebaseio.com',
    projectId: 'bricksandagentservices',
    storageBucket: 'bricksandagentservices.appspot.com',
    messagingSenderId: '165211137623',
  },
  intercom: {
    appId: 'cfn7s491',
  },
  livesession: {
    trackId: 'c25b8a36.67dcd25b',
    isEnable: false,
  },
  invoiceProcessor: {
    baseUrl: 'https://invoiceautomatesimulation.bricksandagent.com',
    isEnable: true,
  },
  keyAutomate: {
    baseUrl: 'https://keyautomatesimulation.bricksandagent.com',
    isEnable: true,
  },
  dataIntercomAttribute: 'data-intercom-target',
  autoRefreshJobDashboard: true,
  stripe: {
    publishableKey: 'pk_test_Za0cv5GtGQ31WrzsCJGOwYUm',
  },
  campaignAgent: {
    scriptUrl: 'https://uat.campaignagent.com.au/ca_payments/ca_payments.js',
  },
  preventSysEmail: true,
  defaultEmail: 'noemail.bna.com',  
  textToSpeech :{
    rate: 1,          // Speed of speech (range [0.1 - 10] , default is 1)
    pitch: 0.3,       // Pitch of the speech (range [0 - 2] , default is 1)
    volume: 1,        // Volume of speech (range [0 - 1], default is 1)
    voice:'Microsoft James - English (Australia)'
  },
  alexAgent: {
    projectId : 'ai-alex-sim',
    agentId : '707eed52-8ece-459f-8fc0-bf18a4d9ec00'
  }
};
